import { render, staticRenderFns } from "./ListUserIntegrationRecordInput.vue?vue&type=template&id=73720271&scoped=true&"
import script from "./ListUserIntegrationRecordInput.vue?vue&type=script&lang=js&"
export * from "./ListUserIntegrationRecordInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73720271",
  null
  
)

export default component.exports